<template>
  <div class="animated fadeIn">
    <b-row>
      <video-tutorial v-if="widgets.length < 1"/>
      <Base v-for="widget in widgets" :widget="widget" v-bind:key="widget.uuid"/>
    </b-row>
  </div>
</template>

<script>
import Base from '../components/widgets/Base'
import VideoTutorial from '../components/widgets/VideoTutorial'

export default {
  name: 'dashboard',
  components: {
    Base,
    VideoTutorial
  },
  data: function () {
    return {}
  },
  computed: {
    widgets() {
      let w = this.$store.getters.widgets

      return w.filter(i => {
        return i.is_active
      })
    }
  },
  methods: {}
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
